var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 10H4.498L4.5 20H6.5V10H4.5ZM6.5 22H4.5C3.397 22 2.5 21.103 2.5 20V10C2.5 8.897 3.397 8 4.5 8H6.5C7.603 8 8.5 8.897 8.5 10V20C8.5 21.103 7.603 22 6.5 22ZM16.0049 11.6924C16.1579 11.6924 16.3129 11.7054 16.4659 11.7294C17.8159 11.9504 18.8329 13.1964 18.8329 14.6294V20.0004H20.4999V14.5384C20.4999 12.0364 18.4819 10.0004 15.9999 10.0004C13.5189 10.0004 11.4999 12.0364 11.4999 14.5384V20.0004H13.1669V14.5384C13.1669 13.6994 13.5319 12.9074 14.1699 12.3654C14.6859 11.9274 15.3349 11.6924 16.0049 11.6924ZM20.4999 22.0004H18.8329C17.7309 22.0004 16.8329 21.1024 16.8329 20.0004V14.6294C16.8329 14.1724 16.5299 13.7664 16.1449 13.7044C15.8089 13.6464 15.5749 13.7964 15.4659 13.8884C15.2759 14.0504 15.1669 14.2874 15.1669 14.5384V20.0004C15.1669 21.1024 14.2699 22.0004 13.1669 22.0004H11.4999C10.3979 22.0004 9.4999 21.1024 9.4999 20.0004V14.5384C9.4999 10.9324 12.4159 8.0004 15.9999 8.0004C19.5839 8.0004 22.4999 10.9324 22.4999 14.5384V20.0004C22.4999 21.1024 21.6029 22.0004 20.4999 22.0004ZM5.5 3C4.948 3 4.5 3.448 4.5 4C4.5 4.552 4.948 5 5.5 5C6.052 5 6.5 4.552 6.5 4C6.5 3.448 6.052 3 5.5 3ZM5.5 7C3.846 7 2.5 5.654 2.5 4C2.5 2.346 3.846 1 5.5 1C7.154 1 8.5 2.346 8.5 4C8.5 5.654 7.154 7 5.5 7Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6df660570094a4308a53bf70e2999b5f.svg";
export { ForwardRef as ReactComponent };